const HIDE_DELAY_MS = 8000;

const initCopyScript = () => {
  const element = document.getElementById("copy-link")
  if (element) {
    element.addEventListener("click", function() {
      copyToClipboardMgs(
        document.getElementById("copy-link-input"),
        "copy-msg"
      );
    });
  }

  document.addEventListener("click", (event) => {
    const target = event.target.closest('[data-flow-close="1"]');
    if (target) {
      document.querySelectorAll('div[data-flow-name]').forEach((element) => {
        element.innerHTML = "";
        element.remove();
      })
    }
  });
}

const copyToClipboardMgs = (element, messageElementId) => {
  const succeed = copyToClipboard(element);
  if (!succeed) {
    document.getElementById(messageElementId).textContent = _copy_button_error;
    selectElementContents("copy-link-input");
  }
  let messageElement = document.getElementById(messageElementId);
  if (messageElement) {
    setTimeout(() => {
      messageElement.classList.add('disabled');
    }, HIDE_DELAY_MS);
  }
}

const copyToClipboard = (element) => {
  return navigator.clipboard.writeText(element.value)
    .then(() => true)
    .catch(() => {
      return false;
    });
}

export { initCopyScript };
